import { Stack, Typography } from '@crossnokaye/ux-common';

import { SubcomponentConfig } from '@/features/equipment-browser/equipment-details/state/related-devices.state';

import { Subcomponent } from './subcomponent';

type SubcomponentSectionProps = {
  subcomponents: SubcomponentConfig[];
  title?: string;
};

export const SubcomponentSection = ({
  subcomponents,
  title,
}: SubcomponentSectionProps): React.ReactNode => {
  return (
    <Stack gap="thin">
      <Typography variant="h4">{title}</Typography>
      {subcomponents?.map((subcomponent: SubcomponentConfig, index: number) => (
        <Subcomponent
          key={`subcomponents-${index}`}
          displayName={subcomponent.displayName}
          icon={subcomponent.icon}
          attributes={subcomponent.attributes}
        />
      ))}
    </Stack>
  );
};
